import { CHZone } from "@app/area/model/ch-zone";
import { CHZoneState, initialZoneState } from "@app/project/store/clarehome.state";
import { getUuid } from "@app/project/store/selectors/projects.selectors";
import { CHApiResultState } from "@app/root-store/api-result.state";
import { State } from "@app/root-store/app.state";
import { ClareHomeDbCollection } from "@app/shared/resources/resource-objectifier";
import { createSelector } from "@ngrx/store";

export type CHZoneStateObj = CHApiResultState<ClareHomeDbCollection<CHZone>>;

export const selectFeature = (state: State) => state.chzone;

export const selectZones = createSelector(selectFeature, getUuid, (state: CHZoneState, uuid: string) =>
    state?.uuid ? state : initialZoneState(uuid)
);

export const selectSortedZonesArray = (zones: CHZoneStateObj) => {
    if (zones?.result) {
        return Object.values(zones.result).sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    }
    return [];
};

export const selectZonesArray = createSelector(selectZones, (zoneState: CHZoneStateObj) => selectSortedZonesArray(zoneState));

export const selectDeviceZones = (uid: string) =>
    createSelector(selectZonesArray, (zones: CHZone[]) =>
        zones.reduce((zoneArray, zone) => {
            if (zone.devices?.includes(uid)) {
                zoneArray.push(zone);
            }

            return zoneArray;
        }, [])
    );
